// removed by extract-text-webpack-plugin
module.exports = {"container":"_1qy6Fea5fd5y7Qu-CrX9-s","heading":"_1xTWGv6RSAy2NN4qcoINdq","headerTitle":"_4QgtESZEBmDmBr0FwvRzO","partnerItem":"_30adjeDl0ilxEleKBeylRy","partnerItemImage":"Buu41lTYQAQYulQo6TTQU","partnerList":"_30Giuj6BMKIcXGW_trURn9"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/partners/partners.css
// module id = 110
// module chunks = 0